module.exports = __webpack_public_path__ + "img/78.1.4e002ace.jpg";